import { useEffect, useMemo } from 'react';

import { ConfirmDialog } from '@gogame/components';
import {
  useScreenModalV2,
  useSearchParams,
  useLinkNavigate,
} from '@gogame/screens';

import { useActionCallback } from '../data';
import { smartRulesDetailsLink, smartRulesLink } from '../navigation';

export const SmartRulesActionCallback = () => {
  const [searchParams] = useSearchParams();
  const confirm = useScreenModalV2(ConfirmDialog);
  const navigateToDetails = useLinkNavigate(smartRulesDetailsLink);
  const navigateToRoot = useLinkNavigate(smartRulesLink);

  const params = useMemo(() => {
    return Array.from(searchParams).reduce((m, pair) => {
      const [k, v] = pair;
      return {
        ...m,
        [k]: v,
      };
    }, {});
  }, [searchParams]);

  const [callback] = useActionCallback();
  useEffect(() => {
    callback(params).then(({ ruleId, message, title }) => {
      confirm({
        title: `${title}`,
        bodyText: message,
        confirmActionLabel: 'Go to details',
        onClose: () => {
          return navigateToRoot({});
        },
      }).then(() => navigateToDetails({ id: ruleId }));
    });
  }, [params]);

  return null;
};
